import { Tooltip } from 'antd';
import styled from 'styled-components';

export const StyledTooltip = styled(Tooltip)``;
